// extracted by mini-css-extract-plugin
export default {"banner-container":"BannerImage_banner-container__t5pjD"};